'use strict';

/**
 * Returns a DW Site Preference value that has been stored client-side (see templates/default/sitePreferences.isml)
 * @param {string} id The Site Preference ID
 * @returns {Object|string|number} The Site Preference value
 */
function getSitePreference(id) {
    // TODO: move site preferences from window object to body element's dataset
    var sitePrefObj = window.SitePreferences;
    return sitePrefObj[id];
}

/**
 * Handles lazy loading of images using Unveil.js
 * @returns {Object|boolean} this for chaining, or false if lazy load is disabled
 */
function lazyLoad() {
    if (getSitePreference('lazyLoadEnabled') === false) {
        // lazy load is turned off in custom Site Preferences
        return false;
    }

    $('.lazy').unveil(getSitePreference('lazyLoadThreshold'), function (element) {
        // callback after an image element is loaded
        if ($(element).hasClass('plp-main-slide')) {
            var productImageCarousel = $(element).closest('.product-image-carousel');
            if (productImageCarousel.length > 0) {
                productImageCarousel.find('.alt-lazy').each(function () {
                    $(this).attr('src', $(this).data('src'));
                });
            }
        }
    }, function (element) {
        // image load error handler
        var errorSrc = $(element).data('src-error');
        $(element).attr('src', errorSrc);
        if ($(element).hasClass('plp-main-slide')) {
            var productImageCarousel = $(element).closest('.product-image-carousel');
            if (productImageCarousel.length > 0) {
                productImageCarousel.find('.alt-lazy').each(function () {
                    $(this).attr('src', $(this).data('src'));
                });
            }
        }
    });

    return this; // fixes a lint error and allows chaining
}

module.exports = {
    lazyLoad: lazyLoad,
    getSitePreference: getSitePreference
};
